let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jSkUD")).then(() => parcelRequire('6bp4T'));